import React from 'react'
import './Logo.scss'

const Logo = ({ data }) => {
    return (
        <div className="logo">
            <img alt="logo" src={`/assets/logo/logo-${data?.logo || 'gray'}.png`} />
            {data && (
                <div>
                    {data?.company?.indexOf('OOO') > -1 &&
                        <h3><span>Институт практической социальной психологии <b>Александра Шахова</b></span></h3>}
                    {data?.company?.indexOf('OOO') === -1 &&
                        <h3><span>Психолог <b>Александр Шахов</b></span></h3>
                    }
                </div>
            )}
        </div>
    )
}

export default Logo
